import {StringKeyed} from "./GenericTypes";

export type ChainService = (underlying: string) => Promise<OptionChain>;

export interface OptionChain {
    readonly code: string;
    readonly asAt: Date;
    readonly cvf: number;
    readonly codes: StringKeyed<Option>;
}

export interface Option {
    readonly code: string;
    readonly security: OptionChain;
    readonly expiry: Date;
    readonly style: OptionStyle;
    readonly type: OptionType;
}

export enum OptionStyle {
    AMERICAN = "AMERICAN",
    EUROPEAN = "EUROPEAN"
}

export enum OptionType {
    PUT = "PUT",
    CALL = "CALL"
}
